export default "__VITE_ASSET__waR1us7___"